import { Address, L2AccountId, L2ChainId, Timestamp, TokenId } from 'types'
import { http } from './http'

export enum HistoryType {
  Deposit = 'DEPOSIT',
  Withdraw = 'WITHDRAW',
  Transfer = 'TRANSFER',
}
export interface HistoryParams {
  pageIndex?: number
  pageSize?: number
  type: HistoryType
  account: number
  limit?: number
  offsetId?: number
}
export enum HistoryStatusType {
  padding = 'PENDING',
  fail = 'FAILED',
  success = 'SUCCESS',
}
export interface ApiHistoryItem {
  txId: number
  ethHash?: string // Only for deposit
  userId: number
  accountId: number
  l2AccountId: L2AccountId
  txHash: string
  txType: HistoryType
  txStatus: HistoryStatusType
  chainId: L2ChainId
  fromAddress: Address
  toAddress: Address
  currencyId: TokenId
  fee: number
  amount: number
  extra: string // E.g. "{\"withdrawFeeRatio\":0,\"withdrawToL1\":0}"
  newPkHash: string
  nonce: number
  ts: Timestamp
  pubKey: string
  signature: string
  ethAuthData: string
  ethSignature: string
  createdAt: Timestamp
  updatedAt: Timestamp
}
export function getHistoryListApi(params: HistoryParams): Promise<{
  data: {
    results: ApiHistoryItem[]
    total: number
  }
}> {
  const { limit, offsetId, type, account } = params
  return http
    .get(`/account/${account}/transactions`, {
      params: {
        limit,
        offsetId,
        type,
      },
    })
    .then((r) => r.data)
}
